import { FC, PropsWithChildren } from 'react';
import { useLogoutMutation } from '../gatewayApi';
import { UseDoLogoutMutationContext } from '../../bo-kit/components/AuthorizedLayout/hooks/useLogout';

const useDoLogout = () => {
    const [trigger, state] = useLogoutMutation();
    // const dispatch = useDispatch();
    // useEffect(() => {
    //     if (state.isSuccess || state.isError) {
    //         dispatch(logout());
    //     }
    // }, [dispatch, state]);
    return [trigger, state.isLoading || state.isUninitialized] as const;
};

export const UseDoLogoutMutationContextProvider: FC<PropsWithChildren> = ({ children }) => {
    const [doLogout, doLogoutInProgress] = useDoLogout();
    return (
        <UseDoLogoutMutationContext.Provider value={[doLogout, doLogoutInProgress]}>
            {children}
        </UseDoLogoutMutationContext.Provider>
    );
};
